import { IMG_PATH } from "../constants";
import axiosInstance from "./axiosInstance";

export async function createBerita(data) {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("content", data.content);
  formData.append("status", data.status);
  formData.append("file", data.file);
  return await axiosInstance.post("/berita", formData);
}

export async function getBerita(search = null) {
  let qs = "";
  if(search) qs = `?search=${search}`
  return await axiosInstance.get(`/berita${qs}`);
}

export async function getBeritaPublish() {
  return await axiosInstance.get("/berita/published");
}

export async function getBeritaDraft() {
  return await axiosInstance.get("/berita/draft");
}

export async function deleteBerita(id) {
  return await axiosInstance.delete(`/berita/${id}`);
}

export async function showBerita(id) {
  return await axiosInstance.get(`/berita/${id}`);
}

export async function editBerita(data) {
  return await axiosInstance.put("/berita", data)
}